<template>
  <section class="trxDetail">
    <Header ref="header" class="scrolled" :class="{uncorupted: type !== 'donation'}"
      :merchandise="type !== 'donation'"/>
    <McHeader class="scrolled" v-if="type !== 'donation'"
      title="Detil Transaksi" :canGoBack="false" ref="mcHeader"/>
    <div class="userModal">
      <div :class="{modalContent: 1, show3Ds: show3Ds}">
        <div class="frameCnt">
          <iframe id="threeDsFrame" name="threeDsFrame"></iframe>
        </div>
        <div class="successCnt" v-if="success">
          <div>
            <div class="success-animation">
              <svg class="checkmark" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"><circle class="checkmark__circle"
                cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check"
                fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
            </div>
            <div v-if="type === 'donation'">
              <h4>Donasi Terkirim</h4>
              <p>Terima kasih telah berdonasi di Sahabat ICW</p>
              <a href="/donasi" class="btn secondary">Tutup</a>
            </div>
            <div v-else>
              <h4>Pembayaran Terverifikasi</h4>
              <p>Terima kasih telah berbelanja di Sahabat ICW X Uncorupted</p>
              <a href="/user/transaksi" v-on:click="close(true)" class="btn primary block">
                Lihat Transaksi</a>
              <a href="/" class="btn secondary block">
                Ke Halaman Utama</a>
            </div>
          </div>
        </div>
        <div class="successCnt pending" v-else-if="pending">
          <div>
            <img src="../assets/trx-pending.png">
            <h4>Menunggu Pembayaran</h4>
            <p>Menunggu pembayaran sebesar <b>Rp {{amount.toLocaleString('id')}}</b> untuk
              <span v-if="type === 'donation'">donasi</span>
              <span v-else>pesanan</span>
              dengan No. Transaksi <b>{{orderNo}}</b>.</p>
            <button class="btn secondary" v-on:click="checkTrxStatus">
              Cek Status Pembayaran</button>
          </div>
        </div>
        <perfect-scrollbar class="vaSuccess" v-if="retailSuccess">
          <h2>Selesaikan pembayaran dalam</h2>
          <div class="countdown">
            {{countdown.hours}}:{{countdown.minutes}}:{{countdown.seconds}}
          </div>
          <div class="deadline">
            <p>Batas akhir pembayaran</p>
            <h4>{{retailSuccess.timestamp + 86400 | moment('dddd, D MMMM YYYY hh:mm')}}</h4>
          </div>
          <div class="theVa">
            <div class="vaHeader">
              <div class="icon" :class="retailSuccess.retailOutletCode.toLowerCase()"></div>
              <h4 v-if="retailSuccess.retailOutletCode === 'ALFAMART'">
                Pembayaran di Gerai Alfamart
              </h4>
              <h4 v-else>
                Pembayaran di Gerai {{retailSuccess.retailOutletCode}}
              </h4>
            </div>
            <div class="vaItem">
              <span class="copy" v-on:click="copy(retailSuccess.retailPaymentNumber)">Salin</span>
              <label>Nomor Pembayaran</label>
              <h4>{{retailSuccess.retailPaymentNumber}}</h4>
            </div>
            <div class="vaItem">
              <span class="copy" v-on:click="copy('Sayangi Anak Ekstra')">
                Salin</span>
              <label>Nama Merchant</label>
              <h4>Sayangi Anak Ekstra</h4>
            </div>
            <div class="vaItem">
              <span class="copy" v-on:click="copy(retailSuccess.amount,
                'Total pembayaran')">Salin</span>
              <label>Total Pembayaran</label>
              <h4>Rp {{retailSuccess.amount.toLocaleString('id')}}</h4>
            </div>
          </div>
          <button class="closeBtn" v-on:click="close(false)">Tutup</button>
        </perfect-scrollbar>
        <perfect-scrollbar class="vaSuccess" v-if="vaSuccess">
          <h2>Selesaikan pembayaran dalam</h2>
          <div class="countdown">
            {{countdown.hours}}:{{countdown.minutes}}:{{countdown.seconds}}
          </div>
          <div class="deadline">
            <p>Batas akhir pembayaran</p>
            <h4>{{vaSuccess.timestamp + 86400 | moment('dddd, D MMMM YYYY hh:mm')}}</h4>
          </div>
          <div class="theVa">
            <div class="vaHeader">
              <div class="icon" :class="vaSuccess.vaBank.toLowerCase()"></div>
              <h4 v-if="vaSuccess.vaBank === 'MANDIRI'">
                Mandiri Virtual Account
              </h4>
              <h4 v-else-if="vaSuccess.vaBank === 'PERMATA'">
                Bank Permata Virtual Account
              </h4>
              <h4 v-else>
                {{vaSuccess.vaBank}} Virtual Account
              </h4>
            </div>
            <div class="vaItem">
              <span class="copy" v-on:click="copy(vaSuccess.vaNumber)">Salin</span>
              <label>Nomor Virtual Account</label>
              <h4>{{vaSuccess.vaNumber}}</h4>
            </div>
            <div class="vaItem">
              <span class="copy" v-on:click="copy('Sayangi Anak Ekstra')">
                Salin</span>
              <label>Atas Nama</label>
              <h4>Sayangi Anak Ekstra</h4>
            </div>
            <div class="vaItem">
              <span class="copy" v-on:click="copy(vaSuccess.amount,
                'Total pembayaran')">Salin</span>
              <label>Total Pembayaran</label>
              <h4>Rp {{vaSuccess.amount.toLocaleString('id')}}</h4>
            </div>
          </div>
          <button class="closeBtn" v-on:click="close(false)">Tutup</button>

          <div class="paymentHowTo">
            <h4>Cara Pembayaran</h4>
            <div class="paymentHowToCnt" v-if="vaSuccess.vaBank === 'PERMATA'">
              <div class="paymentHowToItem">
                <h3>ATM (Prima/Alto)</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input your <b>PIN</b> number.</li>
                  <li>Select <b>Other Transactions</b>.</li>
                  <li>Select <b>Payment Transfer</b>.</li>
                  <li>Select <b>Others</b>.</li>
                  <li>Select <b>Virtual Account Payment</b>.</li>
                  <li>Enter your Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>.</li>
                  <li>On the confirmation page, there will be the amount to pay, account number
                    and merchant name. If the information is already correct, proceed.</li>
                  <li>Choose your source of payment and proceed</li>
                  <li>Your transaction is completed</li>
                  <li>Once the payment transaction is completed, the invoice will be
                    updated automatically. This may take up to 5 minutes.</li>
                </ol>
              </div>
              <div class="paymentHowToItem">
                <h3>Permata Mobile X</h3>
                <ol>
                  <li>Log in to <b>Permata Mobile X</b></li>
                  <li>Choose <b>Pay Bills/Pembayaran Tagihan</b></li>
                  <li>Choose <b>Virtual Account</b></li>
                  <li>Enter Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>.</li>
                  <li>Your billing detail will show on the screen.</li>
                  <li>The amount billed will show on the screen. Choose your source of payment.</li>
                  <li>Confirm your transaction.</li>
                  <li>Enter SMS token response code.</li>
                  <li>Transaction completed.</li>
                  <li>Once the payment transaction is completed, the invoice will be updated
                    automatically. This may take up to 5 minutes.</li>
                </ol>
              </div>
              <div class="paymentHowToItem paymentHowToItemL">
                <h3>Other Bank ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select <b>Others</b></li>
                  <li>Select <b>Transfer</b></li>
                  <li>Select <b>To Other Bank</b></li>
                  <li>Enter Bank Code <b>(Bank Permata: 013)</b> followed by your Virtual
                      Account Number <b>{{vaSuccess.vaNumber}}</b></li>
                  <li>Input the amount billed as Nominal Transfer
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b></li>
                  <li>Keep your receipt as a formal proof of payment.</li>
                  <li>Finish, transaction has been successful</li>
                </ol>
              </div>
            </div>
            <div class="paymentHowToCnt" v-if="vaSuccess.vaBank === 'BNI'">
              <div class="paymentHowToItem">
                <h3>BNI ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select <b>Other Transaction</b>.</li>
                  <li>Select <b>Transfer</b>.</li>
                  <li>Select <b>Virtual Account Billing</b>.</li>
                  <li>Enter your Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>.</li>
                  <li>Enter the amount billed
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b>.</li>
                  <li>Confirm your transaction details displayed.</li>
                  <li>Your transaction is completed.</li>
                  <li>Keep your receipt as a formal proof of payment.</li>
                </ol>
              </div>
              <div class="paymentHowToItem">
                <h3>BNI Mobile Banking</h3>
                <ol>
                  <li>Log in to <b>BNI Mobile Banking App</b></li>
                  <li>Choose <b>Transfer</b></li>
                  <li>Choose <b>Virtual Account Billing</b></li>
                  <li>Enter Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>
                    and the amount billed <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b>.</li>
                  <li>Confirm your billing</li>
                  <li>Enter your password</li>
                  <li>Transaction completed.</li>
                </ol>
              </div>
              <div class="paymentHowToItem paymentHowToItemL">
                <h3>Other Bank ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select <b>Others</b></li>
                  <li>Select <b>Transfer</b></li>
                  <li>Select <b>To Other Bank</b></li>
                  <li>Enter Bank Code <b>(BNI: 009)</b> followed by your Virtual Account Number
                    <b>{{vaSuccess.vaNumber}}</b></li>
                  <li>Input the amount billed as Nominal Transfer
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b></li>
                  <li>Keep your receipt as a formal proof of payment.</li>
                  <li>Finish, transaction has been successful</li>
                </ol>
              </div>
            </div>
            <div class="paymentHowToCnt" v-if="vaSuccess.vaBank === 'BRI'">
              <div class="paymentHowToItem">
                <h3>BRI ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select menu <b>Other Transaction</b>.</li>
                  <li>Select <b>Other</b>.</li>
                  <li>Select <b>Payment</b>.</li>
                  <li>Select <b>Other</b>.</li>
                  <li>Select <b>BRIVA</b>.</li>
                  <li>Enter your BRI Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>,
                    then press <b>Yes</b>.</li>
                  <li>Enter the amount billed
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b>.</li>
                  <li>Confirm your transaction details displayed. Select <b>Yes</b>
                    to confirm your transaction.</li>
                  <li>Keep your receipt as a formal proof of payment.</li>
                </ol>
              </div>
              <div class="paymentHowToItem">
                <h3>BRI Mobile Banking</h3>
                <ol>
                  <li>Log in to <b>BRI Mobile Banking App</b></li>
                  <li>Choose <b>Payment</b></li>
                  <li>Choose <b>BRIVA</b></li>
                  <li>Enter BRI Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>
                    and the amount billed <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b>.</li>
                  <li>Input your <b>PIN</b> number.</li>
                  <li>Click <b>Ok</b> to proceed payment.</li>
                  <li>Transaction completed.</li>
                  <li>A confirmation SMS will be sent to your phone number</li>
                </ol>
              </div>
              <div class="paymentHowToItem paymentHowToItemL">
                <h3>Other Bank ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select <b>Others</b></li>
                  <li>Select <b>Transfer</b></li>
                  <li>Select <b>To Other Bank</b></li>
                  <li>Enter Bank Code <b>(BRI: 002)</b> followed by your Virtual Account
                    Number <b>{{vaSuccess.vaNumber}}</b></li>
                  <li>Input the amount billed as Nominal Transfer
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b></li>
                  <li>Keep your receipt as a formal proof of payment.</li>
                  <li>Finish, transaction has been successful</li>
                </ol>
              </div>
            </div>
            <div class="paymentHowToCnt" v-if="vaSuccess.vaBank === 'BCA'">
              <div class="paymentHowToItem">
                <h3>BCA ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select menu <b>Other Transaction</b>.</li>
                  <li>Select <b>Transfer</b>.</li>
                  <li>Select <b>To BCA Virtual Account</b></li>
                  <li>Enter Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>,
                    then press <b>Correct</b>.</li>
                  <li>Verify Virtual Account details and then enter amount to be transferred
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b> and select
                    <b>Correct</b>.</li>
                  <li>Confirm your transaction details displayed. Select <b>Yes</b> to
                    confirm your transaction.</li>
                  <li>Keep your receipt as a formal proof of payment.</li>
                  <li>Once the payment transaction is completed, the invoice will be
                    updated automatically. This may take up to 5 minutes.</li>
                </ol>
              </div>
              <div class="paymentHowToItem">
                <h3>BCA M-Mobile</h3>
                <ol>
                  <li>Log in to <b>BCA M-Mobile</b></li>
                  <li>Choose <b>m-BCA</b></li>
                  <li>Choose <b>Transfer</b></li>
                  <li>Choose <b>BCA Virtual Account</b></li>
                  <li>Enter Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>,
                    then press <b>Ok</b>.</li>
                  <li>Click <b>Send</b> button placed on top right corner of your application.</li>
                  <li>Click <b>Ok</b> to proceed payment.</li>
                  <li>Input your <b>PIN</b> number.</li>
                  <li>Transaction completed.</li>
                  <li>Once the payment transaction is completed, the invoice will be
                    updated automatically. This may take up to 5 minutes.</li>
                </ol>
              </div>
              <div class="paymentHowToItem paymentHowToItemL">
                <h3>Other Bank ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select <b>Others</b></li>
                  <li>Select <b>Transfer</b></li>
                  <li>Select <b>To Other Bank</b></li>
                  <li>Enter Bank Code <b>(BCA: 014)</b> followed by your Virtual Account
                    Number <b>{{vaSuccess.vaNumber}}</b></li>
                  <li>Input the amount billed as Nominal Transfer
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b></li>
                  <li>Keep your receipt as a formal proof of payment.</li>
                  <li>Finish, transaction has been successful</li>
                  <li>Once the payment transaction is completed, the invoice will be
                    updated automatically. This may take up to 5 minutes.</li>
                </ol>
              </div>
            </div>
            <div class="paymentHowToCnt" v-if="vaSuccess.vaBank === 'MANDIRI'">
              <div class="paymentHowToItem">
                <h3>Mandiri ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select <b>Payment</b>.</li>
                  <li>Select <b>Multi Payment</b>.</li>
                  <li>Enter company code <b>88608 (Xendit 88608)</b> then press <b>Correct</b>.</li>
                  <li>Enter Virtual Account Number <b>{{vaSuccess.vaNumber}}</b>,
                    then press <b>Correct</b>.</li>
                  <li>Enter the amount to transfer
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b>,
                    then press <b>Correct</b>.</li>
                  <li>Customer details will be displayed. Choose number <b>1</b> according
                    to the amount billed and then press <b>Yes</b>.</li>
                  <li>Payment confirmation will be displayed. Select <b>Yes</b> to proceed.</li>
                  <li>Keep your receipt as a formal proof of payment from Mandiri Bank</li>
                  <li>Your transaction is successful</li>
                </ol>
              </div>
              <div class="paymentHowToItem">
                <h3>Mandiri Mobile Banking</h3>
                <ol>
                  <li>Log in to <b>Mobile Banking Mandiri Online</b></li>
                  <li>Click <b>Icon Menu</b> in the top left side</li>
                  <li>Select <b>Payment</b></li>
                  <li>Select <b>Make New Payment</b></li>
                  <li>Select <b>Multi Payment</b></li>
                  <li>Select <b>Xendit 88608</b> as service provider</li>
                  <li>Select Virtual Account Number <b>{{vaSuccess.vaNumber}}</b></li>
                  <li>Enter your virtual account number with <b>88608</b> as Company Code then
                    select <b>Add as New Number</b></li>
                  <li>Input nominal <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b>
                    then select <b>Confirmation</b></li>
                  <li>Select <b>Continue</b></li>
                  <li>Appear payment confirmation page</li>
                  <li>Scroll down in payment confirmation page then select <b>Confirmation</b></li>
                  <li>Input your <b>PIN</b> and the transaction will be completed.</li>
                </ol>
              </div>
              <div class="paymentHowToItem paymentHowToItemL">
                <h3>Other Bank ATM</h3>
                <ol>
                  <li>Insert your <b>ATM Card</b> and input you <b>PIN</b> number.</li>
                  <li>Select <b>Others</b></li>
                  <li>Select <b>Transfer</b></li>
                  <li>Select <b>To Other Bank</b></li>
                  <li>Enter Bank Code <b>(Mandiri: 008)</b> followed by your Virtual Account
                    Number <b>{{vaSuccess.vaNumber}}</b></li>
                  <li>Input the amount billed as Nominal Transfer
                    <b>Rp {{vaSuccess.amount.toLocaleString('id')}}</b></li>
                  <li>Keep your receipt as a formal proof of payment.</li>
                  <li>Finish, transaction has been successful</li>
                </ol>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
        <div class="loading" v-if="loading"></div>
        <transition name="cc">
          <div class="ccCnt" v-if="openCc">
            <div class="back" v-on:click="openCc = false"></div>
            <form v-on:submit.prevent="payCc" method="post">
              <div class="fieldGroup">
                <label>Total Pembayaran</label>
                <div class="price">Rp {{price.toLocaleString('id')}}</div>
              </div>
              <div :class="{fieldGroup: 1, hasError: card.no.error}">
                <div class="fieldCnt">
                  <label>Nomor Kartu</label>
                  <masked-input type="text" name="card_number" class="field"
                    v-model="card.no.model" v-on:input="cardNoChanged"
                    :mask="ccMask"
                    placeholder="4000 0000 0000 0000"
                    :guide="false"></masked-input>
                  <div class="cardIcon" :class="cardType"></div>
                </div>
                <div class="fieldError" v-if="card.no.error">{{card.no.error}}</div>
              </div>
              <div :class="{fieldGroup: 1, hasError: card.name.error}">
                <label>Nama Pemegang Kartu</label>
                <input type="text" class="field" placeholder="Jon Doe"
                  v-on:input="fieldChanged('name')" v-model="card.name.model"
                  name="card_holder_name">
                <div class="fieldError" v-if="card.name.error">{{card.name.error}}</div>
              </div>
              <div class="fieldGroup flex">
                <div :class="{fieldCnt: 1, hasError: card.exp.error}">
                  <label>Masa Kadaluarsa</label>
                  <masked-input type="text" name="expiryDate" class="field"
                    v-model="card.exp.model" v-on:input="expChanged"
                    :mask="[/\d/, /\d/, '/', /\d/, /\d/]"
                    placeholder="MM/YY"
                    :guide="false"></masked-input>
                  <div class="fieldError" v-if="card.exp.error">{{card.exp.error}}</div>
                </div>
                <div :class="{fieldCnt: 1, cvv: 1, hasError: card.cvv.error}">
                  <label>CVV</label>
                  <input type="number" class="field" placeholder="123"
                    v-on:input="fieldChanged('cvv')" v-model="card.cvv.model"
                    name="cvv">
                  <div class="fieldError" v-if="card.cvv.error">{{card.cvv.error}}</div>
                </div>
              </div>
              <div class="fieldGroup hasCheckbox">
                <div class="checkCnt" v-on:click="autodebet = !autodebet">
                  <div class="checkbox" :class="{checked: autodebet}"></div>
                  Autodebet bulanan
                </div>
                <div class="hint">Jika kamu mencentang ini, akan di
                  autodebet setiap bulan sebesar {{amount}} ke kartu kredit kamu</div>
              </div>
              <div class="btnCnt">
                <button type="button" class="btn primary"
                  v-on:click="payCc">Bayar</button>
              </div>
            </form>
          </div>
        </transition>
        <transition name="cc">
          <div class="ccCnt" v-if="openPhone">
            <div class="back" v-on:click="openPhone = false"></div>
            <div v-if="openPhone === 'ovo'">
              <h2>Bayar dengan OVO</h2>
              <p class="subtitle">Masukan nomor telp kamu yang terdaftar di OVO.</p>
            </div>
            <div v-else-if="openPhone === 'link-aja'">
              <h2>Bayar dengan Link-Aja</h2>
              <p class="subtitle">Masukan nomor telp kamu yang terdaftar di Link-Aja.</p>
            </div>
            <form v-on:submit.prevent="payWallet(openPhone)" method="post">
              <div class="fieldGroup">
                <label>Total Pembayaran</label>
                <div class="price">Rp {{price.toLocaleString('id')}}</div>
              </div>
              <div :class="{fieldGroup: 1, hasError: phone.error}">
                <label>Nomor HP</label>
                <input type="text" class="field" placeholder="081"
                  v-on:input="fieldChanged('phone')" v-model="phone.model"
                  name="card_holder_name">
                <div class="fieldError" v-if="phone.error">{{phone.error}}</div>
              </div>
              <div class="btnCnt">
                <button type="button" class="btn btnPrimary"
                  v-on:click="payWallet(openPhone)">Bayar</button>
              </div>
            </form>
          </div>
        </transition>
        <h2 class="main">Kartu Kredit</h2>
        <li class="bankItem disabled_" v-on:click="selectPayment('cc')">
          <div class="icon cc"></div>
          <h4>Kartu Kredit</h4>
          <!-- <p>Metode pembayaran ini tidak tersedia untuk saat ini.</p> -->
        </li>
        <h2>Virtual Akun</h2>
        <li class="bankItem" v-on:click="selectPayment('mandiri')">
          <div class="icon mandiri"></div>
          <h4>Bank Mandiri</h4>
        </li>
        <li class="bankItem disabled_" v-on:click="selectPayment('bca')">
          <div class="icon bca"></div>
          <h4>Bank BCA</h4>
          <!-- <p>Metode pembayaran ini tidak tersedia untuk saat ini.</p> -->
        </li>
        <li class="bankItem" v-on:click="selectPayment('bni')">
          <div class="icon bni"></div>
          <h4>Bank BNI</h4>
        </li>
        <li class="bankItem" v-on:click="selectPayment('bri')">
          <div class="icon bri"></div>
          <h4>Bank BRI</h4>
        </li>
        <li class="bankItem" v-on:click="selectPayment('perma')">
          <div class="icon permata"></div>
          <h4>Bank Permata</h4>
        </li>
        <h2>E-Wallet</h2>
        <li class="bankItem" v-on:click="selectPayment('gopay')">
          <div class="icon gopay"></div>
          <h4>Gopay</h4>
        </li>
        <li class="bankItem disabled_" v-on:click="selectPayment('ovo')"
          v-if="cardProvider === 'xendit'">
          <div class="icon ovo"></div>
          <h4>OVO</h4>
          <!-- <p>Metode pembayaran ini tidak tersedia untuk saat ini.</p> -->
        </li>
        <li class="bankItem" v-on:click="selectPayment('dana')"
          v-if="cardProvider === 'xendit'">
          <div class="icon dana"></div>
          <h4>Dana</h4>
        </li>
        <li class="bankItem" v-on:click="selectPayment('link-aja')"
          v-if="cardProvider === 'xendit'">
          <div class="icon link-aja"></div>
          <h4>Link-Aja</h4>
        </li>
        <h2>Tunai di Gerai Retail</h2>
        <li class="bankItem disabled_" v-on:click="selectPayment('alfamart')">
          <div class="icon alfamart"></div>
          <h4>Alfamart</h4>
          <!-- <p>Metode pembayaran ini tidak tersedia untuk saat ini.</p> -->
        </li>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import McHeader from '@/components/McHeader.vue';
import Confirmation from '@/components/Confirmation.vue';

export default {
  components: { Header, McHeader, Confirmation },
  data() {
    return {
      loading: false,
      type: null,
      openPhone: false,
      ccMask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
      trxId: null,
      autodebet: false,
      amount: 0,
      show: false,
      card: {
        no: { model: '', error: null },
        name: { model: '', error: null },
        exp: { model: '', error: null },
        cvv: { model: '', error: null },
      },
      phone: { model: '', error: null },
      show3Ds: false,
      cardType: 'unknown',
      price: 0,
      openCc: false,
      vaSuccess: null,
      retailSuccess: null,
      countdown: {
        hours: '--', minutes: '--', seconds: '--', finished: false,
      },
      cardProvider: 'midtrans',
      success: false,
      pending: false,
    };
  },
  methods: {
    checkTrxStatus() {
      this.loading = true;
      const uri = (this.type === 'donation')
        ? `user/donation/${this.trxId}/status`
        : `user/purchase/${this.trxId}/status`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        if (r.data.status !== 200) return;
        if (r.data.data === 'Payment Failed') {
          this.$refs.confirmDialog.open({
            title: 'Pembayaran Gagal',
            desc: 'Terjadi kesalahan pada saat melakukan pembayaran, silahkan coba kembali',
            action: 'Tutup',
            confirm: false,
          }, () => {
            window.location.href = '/user/transaksi';
          });
        } else if (r.data.data === 'Payment Expired') {
          this.$refs.confirmDialog.open({
            title: 'Pembayaran Kadaluarsa',
            desc: 'Link pembayaran sudah kadaluarsa, silahkan melakukan pemesanan ulang',
            action: 'Tutup',
            confirm: false,
          }, () => {
            window.location.href = '/user/transaksi';
          });
        } else if (r.data.data === 'Pending') {
          // Do nothing
          this.loading = false;
        } else {
          this.loading = false;
          this.success = true;
        }
      });
    },
    checkTrxStatusWithTimer() {
      if (!this.show) return;
      const uri = (this.type === 'donation')
        ? `user/donation/${this.trxId}/status`
        : `user/purchase/${this.trxId}/status`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        if (r.data.status !== 200) return;
        if (r.data.data === 'Payment Failed') {
          this.$refs.confirmDialog.open({
            title: 'Pembayaran Gagal',
            desc: 'Terjadi kesalahan pada saat melakukan pembayaran, silahkan coba kembali',
            action: 'Tutup',
            confirm: false,
          }, () => {
            window.location.href = '/user/transaksi';
          });
        } else if (r.data.data === 'Payment Expired') {
          this.$refs.confirmDialog.open({
            title: 'Pembayaran Kadaluarsa',
            desc: 'Link pembayaran sudah kadaluarsa, silahkan melakukan pemesanan ulang',
            action: 'Tutup',
            confirm: false,
          }, () => {
            window.location.href = '/user/transaksi';
          });
        } else if (r.data.data === 'Pending') {
          // Do nothing
          setTimeout(() => {
            this.checkTrxStatusWithTimer();
          }, 5000);
        } else {
          this.success = true;
        }
      });
    },
    close(b) {
      this.show = false;
      if (this.next) this.next(b);
    },
    fieldChanged(f) {
      if (f === 'phone') {
        this.phone.error = null;
        return;
      }
      this.card[f].error = null;
    },
    copy(ttc, label) {
      const l = label || ttc;
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = ttc;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.$refs.snackbar.open({
        content: `${l} di salin ke clipboard.`,
      });
    },
    expChanged() {
      if (!this.card.exp.model) return;
      const exp = this.card.exp.model.split('/');
      if (exp.length < 2) {
        this.card.exp.error = 'Masa kadaluarsa tidak valid.';
        return;
      }
      if (!Xendit.card.validateExpiry(exp[0], `20${exp[1]}`)) {
        this.card.exp.error = 'Masa kadaluarsa tidak valid.';
        return;
      }
      this.card.exp.error = null;
    },
    payWallet(walletType) {
      if ((walletType === 'ovo' || walletType === 'link-aja')
        && (!this.phone.model || this.phone.model === '')) {
        this.phone.error = `Mohon masukan no. Hp kamu yang terdaftar di ${walletType}.`;
        return;
      }
      this.loading = true;
      this.$http.post(this.$config.uri(`payment/wallet/${this.type}/${this.trxId}`), {
        walletType,
        phone: this.phone.model,
        redirectUrl: `${this.$config.appUri}payment/${this.type}/${this.trxId}`,
      }).then((r) => {
        if (r.data.status !== 200) {
          this.loading = false;
          const message = r.data.message
            || `Terjadi kesalahan ketika menghubungkan ke server ${walletType}.`;
          this.$refs.confirmDialog.open({
            title: 'Pembayaran Gagal',
            desc: message,
            action: 'Close',
            confirm: false,
          });
          return;
        }
        if (r.data.checkoutUrl) {
          window.location.href = r.data.checkoutUrl;
        }
      });
    },
    cardNoChanged() {
      this.card.no.error = null;
      const cc = this.card.no.model.replaceAll(' ', '');

      const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
      const mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
      const amexpRegEx = /^(?:3[47][0-9]{13})$/;
      const discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
      const jcbRegex = /^(3(?:088|096|112|158|337|5(?:2[89]|[3-8][0-9]))\d{12})$/;

      if (visaRegEx.test(cc)) {
        this.cardType = 'visa';
      } else if (mastercardRegEx.test(cc)) {
        this.cardType = 'mastercard';
      } else if (amexpRegEx.test(cc)) {
        this.cardType = 'amex';
      } else if (jcbRegex.test(cc)) {
        this.cardType = 'jcb';
      } else {
        this.cardType = 'unknown';
      }
    },
    selectPayment(code) {
      if (code === 'cc') {
        this.openCc = true;
      } else if (code === 'gopay') {
        this.loading = true;
        const uri = `user/purchase/midtrans/init/${this.type}/${this.trxId}`;
        this.$http.get(this.$config.uri(uri)).then((r) => {
          if (r.data.status !== 200) {
            const message = result.message
              || 'Payment is not available at the moment, please try again later.';
            this.$refs.confirmDialog.open({
              title: 'Pembayaran Gagal',
              desc: message,
              action: 'Close',
              confirm: false,
            }, () => {
              this.close(false);
            });
            return;
          }

          snap.pay(r.data.data.token, {
            skipOrderSummary: true,
            skipCustomerDetails: true,
            selectedPaymentType: 'gopay',
            onSuccess: (result) => {
              // console.log('Payment Success');
              this.success = true;
            },
            onPending: async (result) => {
              // console.log('Payment Pending');
              this.pending = true;
              this.checkTrxStatusWithTimer();
            },
            onError: (result) => {
              const message = result.message
                || 'Payment is not available at the moment, please try again later.';
              this.$refs.confirmDialog.open({
                title: 'Pembayaran Gagal',
                desc: message,
                action: 'Tutup',
                confirm: false,
              }, () => {
                this.close(false);
              });
            },
            onClose: () => {
              this.close(true);
            },
          });
        });
      } else if (code === 'ovo') {
        this.openPhone = 'ovo';
      } else if (code === 'dana') {
        this.payWallet('dana');
      } else if (code === 'link-aja') {
        this.openPhone = 'link-aja';
      } else if (code === 'alfamart') {
        this.loading = true;
        this.$http.post(this.$config.uri(`payment/retail/${this.type}/${this.trxId}`), {
          retailCode: code.toUpperCase(),
        }).then((r) => {
          this.loading = false;
          if (r.data.status !== 200) {
            const message = r.data.message
              || 'Terjadi kesalahan ketika generate Virtual Account untuk pembayaran di Gerai.';
            this.$refs.confirmDialog.open({
              title: 'Pembayaran Gagal',
              desc: message,
              action: 'Close',
              confirm: false,
            });
            return;
          }
          this.$socket.emit('signPayment', {
            id: r.data.data.id,
            authorization: this.$session.get('jwt'),
          });
          this.retailSuccess = r.data.data;
          const cdDate = (this.retailSuccess.timestamp + 86400) * 1000;
          const x = setInterval(() => {
            const now = Date.now();
            const distance = cdDate - now;
            const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const s = Math.floor((distance % (1000 * 60)) / 1000);
            this.countdown.hours = (h < 10) ? `0${h.toString()}` : h.toString();
            this.countdown.minutes = (m < 10) ? `0${m.toString()}` : m.toString();
            this.countdown.seconds = (s < 10) ? `0${s.toString()}` : s.toString();
            if (distance < 0) {
              clearInterval(x);
              this.countdown.finished = true;
            }
          }, 1000);
        });
      } else {
        this.loading = true;
        if (this.cardProvider === 'midtrans') {
          const uri = `user/purchase/midtrans/init/${this.type}/${this.trxId}`;
          this.$http.get(this.$config.uri(uri)).then((r) => {
            if (r.data.status !== 200) {
              const message = r.data.message
                || 'Payment provider is not available at the moment, please try again later.';
              this.$refs.confirmDialog.open({
                title: 'Pembayaran Gagal',
                desc: message,
                action: 'Tutup',
                confirm: false,
              }, () => {
                this.close(false);
              });
              return;
            }
            snap.pay(r.data.data.token, {
              skipOrderSummary: true,
              skipCustomerDetails: true,
              // selectedPaymentType: 'gopay',
              onSuccess: (result) => {
                // console.log('Payment Success');
                this.loading = false;
                this.success = true;
              },
              onPending: async (result) => {
                // console.log('Payment Pending');
                this.loading = false;
                this.pending = true;
                this.checkTrxStatusWithTimer();
              },
              onError: (result) => {
                this.loading = false;
                const message = result.message
                  || 'Pembayaran di batalkan, silahkan coba lagi untuk melakukan pembayaran.';
                this.$refs.confirmDialog.open({
                  title: 'Pembayaran Gagal',
                  desc: message,
                  action: 'Tutup',
                  confirm: false,
                }, () => {
                  this.close(false);
                });
              },
              onClose: () => {
                // this.loading = false;
                this.close(false);
              },
            });
          });
        } else if (this.cardProvider === 'xendit') {
          this.$http.post(this.$config.uri(`payment/va/${this.type}/${this.trxId}`), {
            bankCode: code.toUpperCase(),
          }).then((r) => {
            this.loading = false;
            if (r.data.status !== 200) {
              const message = r.data.message
                || 'Terjadi kesalahan ketika generate Virtual Account.';
              this.$refs.confirmDialog.open({
                title: 'Pembayaran Gagal',
                desc: message,
                action: 'Close',
                confirm: false,
              });
              return;
            }
            this.$socket.emit('signPayment', {
              id: r.data.data.id,
              authorization: this.$session.get('jwt'),
            });
            this.vaSuccess = r.data.data;
            const cdDate = (this.vaSuccess.timestamp + 86400) * 1000;
            const x = setInterval(() => {
              const now = Date.now();
              const distance = cdDate - now;
              const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              const s = Math.floor((distance % (1000 * 60)) / 1000);
              this.countdown.hours = (h < 10) ? `0${h.toString()}` : h.toString();
              this.countdown.minutes = (m < 10) ? `0${m.toString()}` : m.toString();
              this.countdown.seconds = (s < 10) ? `0${s.toString()}` : s.toString();
              if (distance < 0) {
                clearInterval(x);
                this.countdown.finished = true;
              }
            }, 1000);
          });
        }
      }
    },
    payCc() {
      const cardExpArr = this.card.exp.model.split('/');
      const cardExpStr = `${cardExpArr[0]}/20${cardExpArr[1]}`;
      const formData = {
        no: this.card.no.model.replaceAll(' ', ''),
        name: this.card.name.model,
        exp: cardExpStr,
        cvv: this.card.cvv.model,
      };
      if (!formData.no || formData.no === '') {
        this.card.no.error = 'Mohon masukan nomor Kartu Kredit.';
        return;
      }
      if (this.cardType === 'unknown') {
        this.card.no.error = 'Jenis kartu kredit tidak dikukung.';
        return;
      }
      if (!Xendit.card.validateCardNumber(formData.no)) {
        this.card.no.error = 'Nomor kartu kredit tidak valid.';
        return;
      }

      if (!formData.name || formData.name === '') {
        this.card.name.error = 'Mohon masukan nama pemegang kartu.';
        return;
      }

      if (!formData.exp || formData.exp === '') {
        this.card.exp.error = 'Masukan masa kadaluarsa.';
        return;
      }
      const exp = formData.exp.split('/');
      if (exp.length < 2) {
        this.card.exp.error = 'Masa kadaluarsa tidak valid.';
        return;
      }
      if (!Xendit.card.validateExpiry(exp[0], exp[1])) {
        this.card.exp.error = 'Masa kadaluarsa tidak valid.';
        return;
      }

      if (!formData.cvv || formData.cvv === '') {
        this.card.cvv.error = 'CVV required.';
        return;
      }
      if (!Xendit.card.validateCvn(exp[0], exp[1])) {
        this.card.exp.error = 'CVV tidak valid.';
        return;
      }

      this.loading = true;
      if (this.cardProvider === 'xendit') {
        Xendit.card.createToken({
          amount: this.price,
          card_number: formData.no,
          card_exp_month: exp[0],
          card_exp_year: exp[1],
          card_cvn: formData.cvv,
          is_multiple_use: false,
        }, (err, creditCardCharge) => {
          if (err) {
            this.loading = false;
            const message = err.message || 'Terjadi kesalahan pada verifikasi kartu kredit.';
            this.$refs.confirmDialog.open({
              title: 'Pembayaran Gagal',
              desc: message,
              action: 'Close',
              confirm: false,
            });
          }
          if (creditCardCharge.status === 'VERIFIED') {
            this.show3Ds = false;
            this.loading = true;

            /**
             * Submit token to server
             *
             */
            this.$http.post(this.$config.uri(`payment/card/${this.type}/${this.trxId}`), {
              tokenId: creditCardCharge.id,
              authId: creditCardCharge.authentication_id,
            }).then((r) => {
              if (r.data.status !== 200) {
                this.loading = false;
                const message = r.data.message
                  || 'Terjadi kesalahan ketika melakukan pembayaran menggunakan kartu kredit.';
                this.$refs.confirmDialog.open({
                  title: 'Pembayaran Gagal',
                  desc: message,
                  action: 'Close',
                  confirm: false,
                });
                return;
              }
              this.close(true);
            });
          } else if (creditCardCharge.status === 'IN_REVIEW') {
            this.loading = false;
            this.show3Ds = true;
            window.open(creditCardCharge.payer_authentication_url, 'threeDsFrame');
          } else if (creditCardCharge.status === 'FAILED') {
            this.loading = false;
            const message = creditCardCharge.failure_reason || 'Terjadi kesalahan pada verifikasi kartu kredit.';
            this.$refs.confirmDialog.open({
              title: 'Pembayaran Gagal',
              desc: message,
              action: 'Close',
              confirm: false,
            });
          }
        });
      } else if (this.cardProvider === 'midtrans') {
        MidtransNew3ds.getCardToken({
          card_number: formData.no,
          card_exp_month: cardExpArr[0],
          card_exp_year: `20${cardExpArr[1]}`,
          card_cvv: formData.cvv,
        }, {
          onSuccess: (r) => {
            // Success to get card token_id, implement as you wish here
            // console.log('Success to get card token_id, response:', r);
            // console.log('This is the card token_id:', r.token_id);
            // Implement sending the token_id to backend to proceed to next step
          },
          onFailure: (r) => {
            // Fail to get card token_id, implement as you wish here
            // console.log('Fail to get card token_id, response:', r);
            // you may want to implement displaying failure message to customer.
            // Also record the error message to your log, so you can review
            // what causing failure on this transaction.
          },
        });
      }
    },
  },
  beforeDestroy() {
    this.show = false;
  },
  mounted() {
    this.type = 'product';
    this.vaSuccess = null;
    this.retailSuccess = null;
    this.show3Ds = false;
    this.loading = true;
    this.success = false;
    this.pending = false;
    this.show = true;
    const { id } = this.$route.params;
    this.type = this.$route.params.type;
    const uri = (this.type === 'donation') ? `user/donation/${id}` : `user/purchase/${id}`;
    this.$http.get(this.$config.uri(uri)).then((r) => {
      // this.loading = false;
      if (r.data.status !== 200) {
        this.$refs.confirmDialog.open({
          title: 'Transaksi Tidak Ditemukan',
          desc: 'Mohon periksa kembali url yang kamu masukan',
          action: 'Tutup',
          confirm: false,
        }, () => {
          if (this.type === 'donation') window.location.href = '/donasi';
          else window.location.href = '/user/transaksi';
        });
        return;
      }
      this.trxId = r.data.data.id;
      this.orderNo = r.data.data.orderNo;
      this.amount = (this.type === 'donation') ? r.data.data.amount : r.data.data.grandTotal;
      if (r.data.data.status === 'Payment Failed') {
        this.$refs.confirmDialog.open({
          title: 'Pembayaran Gagal',
          desc: 'Terjadi kesalahan pada saat melakukan pembayaran, silahkan coba kembali',
          action: 'Tutup',
          confirm: false,
        }, () => {
          if (this.type === 'donation') window.location.href = '/donasi';
          else window.location.href = '/user/transaksi';
        });
      } else if (r.data.data === 'Payment Expired') {
        this.$refs.confirmDialog.open({
          title: 'Pembayaran Kadaluarsa',
          desc: 'Link pembayaran sudah kadaluarsa, silahkan melakukan pemesanan ulang',
          action: 'Tutup',
          confirm: false,
        }, () => {
          if (this.type === 'donation') window.location.href = '/donasi';
          else window.location.href = '/user/transaksi';
        });
      } else if (r.data.data.status === 'Pending') {
        this.loading = false;
        this.pending = true;
        this.checkTrxStatusWithTimer();
      } else {
        this.loading = false;
        this.success = true;
      }
    });
  },
};
</script>

<style lang="scss">
  .credit-card-field-wrapper .form-control.credit-card-field .credit-card-field-icon-wrapper{
    width: 56px;
  }
  .credit-card-field-wrapper{
    margin-bottom: 20px;
  }
  .credit-card-field-wrapper .form-control.credit-card-field,
  .credit-card-field-wrapper .form-control.credit-card-field.form-control-md{
    border-radius: 5px;
    border: #999 1px solid;
    height: 60px;
  }
  .credit-card-field-wrapper .form-control.credit-card-field .credit-card-field-fields{
    width: calc(100% - 56px);
    left: 56px;
  }
  .credit-card-field-wrapper .form-control.credit-card-field .credit-card-field-icon-card{
    width: 56px;
  }
  .credit-card-field-wrapper .form-control.credit-card-field .credit-card-field-icon-card
  .credit-card-field-icon-front, .credit-card-field-wrapper .form-control.credit-card-field
  .credit-card-field-icon-card .credit-card-field-icon-back{
    width: 56px;
  }
  .credit-card-field-wrapper .form-control.credit-card-field .credit-card-field-field,
  .credit-card-field-wrapper .form-control.credit-card-field input.credit-card-field-field{
    font-size: 20px;
    padding-top: 11px;
  }
  .credit-card-field.form-control.form-control-md.credit-card-field-primary.last-focused-number{
    .credit-card-field-field.credit-card-field-number{
      transform: translateX(-140px) !important;
    }
  }
  .credit-card-field-wrapper .form-control.credit-card-field:not(.is-focused)
  .credit-card-field-security-fields, .credit-card-field-wrapper
  .form-control.credit-card-field.is-focused-number .credit-card-field-security-fields{
    transform: translateX(-88px);
  }
  .credit-card-field-postal{
    display: none !important;
  }
</style>

<style scoped lang="scss">
.checkCnt{
  position: relative;
  padding-left: 28px;
  font-weight: 600;
  cursor: pointer;
  .checkbox{
    left: 0;
  }
}
.fieldGroup.hasCheckbox{
  .hint{
    padding-left: 27px;
    padding-top: 2px;
  }
}

.userModal{
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 76px 0 0;
  @media (max-width: 680px) {
    padding: 0;
    display: block;
  }

  .fieldCnt.hasPrefix{
    position: relative;
    .field{
      padding-left: 40px;
    }
    .fieldPrefix{
      position: absolute;
      left: 10px; top: 35px;
      z-index: 3;
      color: #767676;
    }
  }

  .fieldCnt{
    .cardIcon{
      position: absolute;
      width: 46px;
      height: 30px;
      background-color: #fff;
      // border: #eee 1px solid;
      z-index: 2;
      top: 34px;
      right: 12px;
      // border-radius: 3px;
      background-image: url(../assets/bank/credit-card-icon.png);
      background-size: contain;
      background-position: right center;
      background-repeat: no-repeat;
      &.visa{
        background-image: url(../assets/bank/visa.png);
        right: 10px;
        background-position: center;
        background-size: 36px auto;
        background-color: #020ed4;
        border-radius: 3px;
      }
      &.mastercard{
        background-image: url(../assets/bank/mc.svg);
      }
      &.jcb{
        background-image: url(../assets/bank/jcb.svg);
        background-size: 50px auto;
        background-position: 50% -1px;
      }
      &.amex{
        background-image: url(../assets/bank/amex.svg);
      }
      &.unknown{
        background-size: 96% auto;
        opacity: .7;
      }
    }
  }

  .price{
    font-weight: 600;
    font-size: 34px;
    padding-left: 3px;
  }

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 420px;
    margin: auto;
    border-radius: 5px;
    padding: 40px 40px;
    overflow: hidden;
    transition: all .3s ease;
    box-sizing: border-box;
    min-height: 280px;
    border: #eee 1px solid;
    line-height: 1.2;
    @media (max-width: 680px) {
      min-height: calc(100vh - 20px);
      width: 100%;
      margin: 20px 0 0;
      border-radius: 15px 15px 0 0;
      padding: 40px 16px;
    }
    .frameCnt{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      z-index: 98;
      display: none;
      iframe{
        position: absolute;
        left: 0; top: 0;
        width: 100%; height: 100%;
        border: none;
        background-color: #fff;
        top: 40px; height: calc(100% - 40px);
      }
    }
    &.show3Ds{
      .frameCnt{
        display: block;
      }
    }
    .successCnt{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      z-index: 98;
      overflow-y: auto;
      text-align: center;
      box-sizing: border-box;
      padding: 30px 16px;
      line-height: 1.2;
      display: flex;
      align-items: center;
      justify-content: center;
      .success-animation{
        .checkmark{
          width: 100px;
          height: 100px;
          border-radius: 50%;
          display: block;
          stroke-width: 2;
          stroke: #4bb71b;
          stroke-miterlimit: 10;
          box-shadow: inset 0px 0px 0px #4bb71b;
          animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
          margin: 0 auto;
        }
        .checkmark__circle{
          stroke-dasharray: 166;
          stroke-dashoffset: 166;
          stroke-width: 2;
          stroke-miterlimit: 10;
          stroke: #4bb71b;
          fill: #fff;
          animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
        }
        .checkmark__check{
          transform-origin: 50% 50%;
          stroke-dasharray: 48;
          stroke-dashoffset: 48;
          animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
        }
        @keyframes stroke {
          100% {
            stroke-dashoffset: 0;
          }
        }
        @keyframes scale {
          0%, 100% {
            transform: none;
          }
          50% {
            transform: scale3d(1.1, 1.1, 1);
          }
        }
        @keyframes fill {
          100% {
            box-shadow: inset 0px 0px 0px 30px #4bb71b;
          }
        }
      }
      h4{
        margin: 30px 0 6px;
        font-size: 22px;
      }
      p{
        margin: 0 10px 30px;
        color: #767676;
        font-size: 15px;
        line-height: 1.4;
      }
      .btn.block{
        width: 164px;
        margin: 0 auto 10px;
        display: block;
      }
      &.pending{
        img{
          height: 96px;
        }
        p{
          margin-bottom: 20px;
        }
      }
    }
    .vaSuccess{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      z-index: 98;
      overflow-y: auto;
      text-align: center;
      box-sizing: border-box;
      padding: 30px 16px;
      line-height: 1.2;
      h2{
        font-size: 18px;
        margin: 0 0 10px;
      }
      .countdown{
        margin: 0 0 8px;
        font-weight: 600;
        font-size: 40px;
        color: #04777b;
      }
      .deadline{
        p{
          margin: 0 0 4px;
          color: #767676;
          font-size: 14px;
        }
        h4{
          font-size: 16px;
          margin: 0;
        }
      }
      .theVa{
        text-align: left;
        border-radius: 5px;
        border: #eee 1px solid;
        padding: 10px 20px 0;
        margin: 20px 0;
        .vaHeader{
          border-bottom: #eee 1px solid;
          margin: 0 -20px 22px;
          padding: 0 80px 8px 20px;
          position: relative;
          .icon{
            position: absolute;
            top: 0; bottom: 10px; right: 10px;
            width: 50px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            &.mandiri{
              background-image: url(../assets/bank/mandiri.png);
            }
            &.bca{
              background-image: url(../assets/bank/bca.png);
            }
            &.bri{
              background-image: url(../assets/bank/briva.png);
            }
            &.bni{
              background-image: url(../assets/bank/bni.png);
            }
            &.permata{
              background-image: url(../assets/bank/permata.png);
            }
            &.alfamart{
              background-image: url(../assets/bank/alfamart.png);
            }
          }
          h4{
            margin: 0;
            font-weight: 600;
            font-size: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .vaItem{
          padding-bottom: 22px;
          label{
            display: block;
            color: #767676;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 12px;
          }
          h4{
            font-weight: 500;
            margin: 0;
            font-size: 20px;
          }
          .copy{
            font-weight: 600;
            color: #04777b;
            float: right;
            font-size: 16px;
            margin-top: 10px;
            cursor: pointer;
            &:hover{
              color: #02c3aa;
            }
          }
        }
      }
      .closeBtn{
        border: #04777b 1px solid;
        border-radius: 30px;
        background-color: #fff;
        color: #04777b;
        padding: 0 18px;
        height: 34px;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
        outline: 0 !important;
        &:hover{
          background-color: #02c3aa;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
          color: #fff;
        }
      }
      .paymentHowTo{
        text-align: left;
        h4{
          font-size: 26px;
          text-align: center;
          margin: 40px 0 20px;
        }
        .paymentHowToItem{
          border: #eee 1px solid;
          border-radius: 5px;
          padding: 12px 20px 6px;
          margin-bottom: 20px;
          h3{
            margin: 0 -20px 14px;
            padding: 0 20px 10px;
            border-bottom: #eee 1px solid;
            font-size: 17px;
            font-weight: 600;
          }
          ol{
            padding: 0;
            margin: 0;
            padding-left: 20px;
          }
          li{
            cursor: default;
            padding: 0;
            padding-left: 14px;
            list-style: lower-alpha;
            background: none !important;
            padding-bottom: 8px;
            font-size: 15px;
            b{
              font-weight: 600;
            }
          }
        }
      }
    }
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-size: 80px auto;
      background-repeat: no-repeat;
      z-index: 99;
      &:before{
        content: "";
        width: 30px; height: 30px;
        background-image: url(../assets/private.png);
        background-size: 100%;
        top: 50%; left: 50%;
        margin: -15px 0 0 -15px;
        position: absolute;
        opacity: .5;
      }
    }
    h2{
      margin: 20px 0 5px 10px;
      font-size: 12px;
      font-weight: 800;
      text-transform: uppercase;
      color: #888;
      &.main{
        margin-top: 0;
      }
    }
    li.bankItem{
      list-style: none;
      padding: 8px 0;
      padding-left: 56px;
      position: relative;
      cursor: pointer;
      &:hover{
        background-color: #f5f5fe;
      }
      &:active{
        transform: scale(.98);
        background-color: #ebebf9;
      }
      &.disabled{
        filter: grayscale(1);
        opacity: .6;
        background-color: #fff;
        cursor: default;
      }
      .icon{
        position: absolute;
        left: 10px; top: 50%;
        width: 30px; height: 26px;
        margin-top: -13px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        &.alfamart{
          background-image: url(../assets/bank/alfamart.png);
        }
        &.cc{
          background-image: url(../assets/bank/credit-card.png);
        }
        &.mandiri{
          background-image: url(../assets/bank/mandiri.png);
        }
        &.bca{
          background-image: url(../assets/bank/bca.png);
        }
        &.bri{
          background-image: url(../assets/bank/briva.png);
        }
        &.bni{
          background-image: url(../assets/bank/bni.png);
        }
        &.permata{
          background-image: url(../assets/bank/permata.png);
        }
        &.gopay{
          background-image: url(../assets/bank/gopay.png);
          height: 30px;
          margin-top: -15px;
        }
        &.ovo{
          background-image: url(../assets/bank/payment_ovo.png);
        }
        &.dana{
          background-image: url(../assets/bank/payment_dana.png);
        }
        &.link-aja{
          background-image: url(../assets/bank/payment_link_aja.png);
          height: 22px;
          margin-top: -11px;
        }
      }
      h4{
        margin: 0;
        font-weight: 500;
        font-size: 15px;
      }
      p{
        margin: 0;
        font-size: 12px;
        color: #767676;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .ccCnt.cc-enter-active, .ccCnt.cc-leave-active {
      opacity: 1;
      transform: translateY(0);
    }
    .ccCnt.cc-enter, .ccCnt.cc-leave-to{
      opacity: 0;
      transform: translateY(40px);
    }
    .ccCnt{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      z-index: 8;
      box-sizing: border-box;
      padding: 40px;
      transition: all .2s ease;
      @media (max-width: 680px) {
        padding: 40px 30px;
      }
      .back{
        width: 36px; height: 36px;
        border-radius: 50%;
        background-image: url(../assets/arrow-back.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        transition: all .3s ease;
        margin-left: -4px;
        opacity: .7;
        &:hover{
          background-color: #eee;
          opacity: 1;
        }
      }
      h2{
        margin: 10px 0 20px 3px;
      }
      .subtitle{
        margin: -16px 0 20px 3px;
        font-size: 14px;
        color: #767676;
      }
      .fieldGroup{
        label{
          text-transform: uppercase;
          font-weight: 600;
          font-size: 12px;
          padding: 4px 4px 2px;
          color: #767676;
          display: block;
        }
        &.flex{
          display: flex;
          .fieldCnt{
            width: calc(64% - 14px);
            margin-right: auto;
            &.cvv{
              width: 36%;
              margin-right: 0;
            }
          }
        }
      }
      .btnCnt{
        text-align: right;
      }
      .btn{
        margin-top: 4px;
        font-size: 20px;
        padding-left: 60px;
        padding-right: 30px;
        position: relative;
        &:before{
          position: absolute;
          content: "";
          top: 0; bottom: 0; left: 26px;
          width: 22px;
          background-image: url(../assets/verified-white.png);
          background-position: right center;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }

  }
}
</style>
